/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery,
  type DataTag,
  type MutationFunction,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationReturnType,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useMutationOptions } from ".././mutationOptions.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  Error,
  RegisterInterestRequest,
  RenewalCreationRequest,
  RenewalCreationResponse,
  RenewalEligibilityResponse,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Register interest for renewing the agreement for an account
 */
export const registerRenewalInterest = (
  accountId: MaybeRefOrGetter<number>,
  registerInterestRequest: MaybeRefOrGetter<RegisterInterestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  registerInterestRequest = toValue(registerInterestRequest)

  return customInstance<void>(
    {
      url: `/api/v1/accounts/${accountId}/renewals/interest`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: registerInterestRequest,
      signal,
    },
    options,
  )
}

export const useRegisterRenewalInterestMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerRenewalInterest>>,
    TError,
    { accountId: number; data: RegisterInterestRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerRenewalInterest>>,
  TError,
  { accountId: number; data: RegisterInterestRequest },
  TContext
> => {
  const mutationKey = ["registerRenewalInterest"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerRenewalInterest>>,
    { accountId: number; data: RegisterInterestRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return registerRenewalInterest(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type RegisterRenewalInterestMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerRenewalInterest>>
>
export type RegisterRenewalInterestMutationBody = RegisterInterestRequest
export type RegisterRenewalInterestMutationError = ErrorType<Error>

/**
 * @summary Register interest for renewing the agreement for an account
 */
export const useRegisterRenewalInterest = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerRenewalInterest>>,
      TError,
      { accountId: number; data: RegisterInterestRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof registerRenewalInterest>>,
  TError,
  { accountId: number; data: RegisterInterestRequest },
  TContext
> => {
  return useMutation(
    useRegisterRenewalInterestMutationOptions(options),
    queryClient,
  )
}
/**
 * @summary Whether a renewal can start for the account now and, if not, why
 */
export const getRenewalEligibility = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<RenewalEligibilityResponse>(
    {
      url: `/api/v1/accounts/${accountId}/renewals/eligibility`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetRenewalEligibilityQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return [
    "api",
    "v1",
    "accounts",
    accountId,
    "renewals",
    "eligibility",
  ] as const
}

export const useGetRenewalEligibilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getRenewalEligibility>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRenewalEligibility>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetRenewalEligibilityQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRenewalEligibility>>
  > = ({ signal }) => getRenewalEligibility(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getRenewalEligibility>>,
    TError,
    TData
  >
}

export type GetRenewalEligibilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRenewalEligibility>>
>
export type GetRenewalEligibilityQueryError = ErrorType<Error>

/**
 * @summary Whether a renewal can start for the account now and, if not, why
 */

export function useGetRenewalEligibility<
  TData = Awaited<ReturnType<typeof getRenewalEligibility>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRenewalEligibility>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetRenewalEligibilityQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Renew customer on to a stored renewal quote
 */
export const createRenewal = (
  accountId: MaybeRefOrGetter<number>,
  renewalCreationRequest: MaybeRefOrGetter<RenewalCreationRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  renewalCreationRequest = toValue(renewalCreationRequest)

  return customInstance<RenewalCreationResponse>(
    {
      url: `/api/v1/accounts/${accountId}/renewals`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: renewalCreationRequest,
      signal,
    },
    options,
  )
}

export const useCreateRenewalMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRenewal>>,
    TError,
    { accountId: number; data: RenewalCreationRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRenewal>>,
  TError,
  { accountId: number; data: RenewalCreationRequest },
  TContext
> => {
  const mutationKey = ["createRenewal"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRenewal>>,
    { accountId: number; data: RenewalCreationRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return createRenewal(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type CreateRenewalMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRenewal>>
>
export type CreateRenewalMutationBody = RenewalCreationRequest
export type CreateRenewalMutationError = ErrorType<Error>

/**
 * @summary Renew customer on to a stored renewal quote
 */
export const useCreateRenewal = <TError = ErrorType<Error>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRenewal>>,
      TError,
      { accountId: number; data: RenewalCreationRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof createRenewal>>,
  TError,
  { accountId: number; data: RenewalCreationRequest },
  TContext
> => {
  return useMutation(useCreateRenewalMutationOptions(options), queryClient)
}
